import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
import Vue from 'vue'

export default Vue.extend({
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
})
